import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Kinesiología: Carrera Resuelta — Sistema Completo para Estudiantes de Kinesiología Argentina';
// Preconnect ONLY to Cloudinary (the critical origin for hero + product images)
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://res.cloudinary.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// dns-prefetch is much cheaper than preconnect — use for non-critical origins.
// Unsplash removed (no longer used). Only Facebook Pixel origin remains.
const dnsPrefetchOrigins = ['https://connect.facebook.net'];
dnsPrefetchOrigins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'dns-prefetch';
  link.href = href;
  document.head.appendChild(link);
});
// Preload hero image for faster LCP — keep variants conservative so mobile
// retina (~640 logical px) still picks a small variant. MUST match App.tsx.
const HERO_BASE = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto';
const HERO_PATH = '/v1777816369/hf_20260503_134623_1bb422cd-84e7-4ec9-9a58-4fe2f3159cdc-Photoroom_d73vml.webp';
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = `${HERO_BASE},w_320${HERO_PATH}`;
preloadImg.setAttribute('imagesrcset', `${HERO_BASE},w_240${HERO_PATH} 240w, ${HERO_BASE},w_320${HERO_PATH} 320w, ${HERO_BASE},w_480${HERO_PATH} 480w`);
preloadImg.setAttribute('imagesizes', '(max-width: 640px) 280px, 380px');
preloadImg.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadImg);
const container = document.getElementById('root')!;
createRoot(container).render(<App data-id="element-377" />);